import { Action } from '@ngrx/store';
import { UserPreferencesData } from '../models/user-preferences-data';

export const LOAD_EFFECTIVE_VALUES = '[User Preference] Load Effective Values';
export const LOAD_EFFECTIVE_VALUES_COMPLETE = '[User Preference] Load Effective Values Complete';
export const LOAD_EFFECTIVE_VALUES_ERROR = '[User Preference] Load Effective Values Error';

export class LoadEffectiveValues implements Action {
    readonly type = LOAD_EFFECTIVE_VALUES;
    constructor() { }
  }
  
  export class LoadEffectiveValuesComplete implements Action {
    readonly type = LOAD_EFFECTIVE_VALUES_COMPLETE;
    constructor(public payload: UserPreferencesData) { }
  }
  
  export class LoadEffectiveValuesError implements Action {
    readonly type = LOAD_EFFECTIVE_VALUES_ERROR;
    constructor(public payload: any) { }
  }

  export type Actions =
  LoadEffectiveValues |
  LoadEffectiveValuesComplete | 
  LoadEffectiveValuesError;